module.exports = __webpack_public_path__ + "img/l-header-bg.ba223a1f.png";